export const ProductOptionTypes = [
    {
        name: 'Множественный',
        value: 'multiple'
    },
    {
        name: 'Одиночный',
        value: 'single'
    }
]